import { render, staticRenderFns } from "./tempSSPAFasa1.vue?vue&type=template&id=4127cb83&scoped=true&"
import script from "./tempSSPAFasa1.vue?vue&type=script&lang=js&"
export * from "./tempSSPAFasa1.vue?vue&type=script&lang=js&"
import style0 from "./tempSSPAFasa1.vue?vue&type=style&index=0&id=4127cb83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4127cb83",
  null
  
)

export default component.exports